import React from "react";
import { useNavigate } from "react-router-dom";

const SubjectiveExamPricing = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path); // Navigate to the given path
  };
  return (
    <div id="allnotes-inner-wrapper">
      {/* Adjust the import path according to your project structure */}
      <div className="allnotes-table-wrapper">
        <h5 className="mx-4">Choose a Category</h5>
        <div className="allnotes-cards-wrapper">
          {/* School Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick(
                "/subjective-exam-pricing/add-school-subjective-exam-pricing"
              )
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>School Subjective Exam (Pricing)</b>
            </div>
          </div>

          {/* College Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick(
                "/subjective-exam-pricing/add-university-subjective-exam-pricing"
              )
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>University Subjective Exam (Pricing)</b>
            </div>
          </div>

          {/* Competitive Exam Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick(
                "/subjective-exam-pricing/add-competition-subjective-exam-pricing"
              )
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>Competitive Subjective Exam (Pricing)</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectiveExamPricing;
